import React from 'react';

const ScanHistoryModal = ({ scanHistory, show, onClose }) => {
  if (!show) return null;
  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Scan History</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {scanHistory.length === 0 ? (
              <div className="text-muted">No scans yet.</div>
            ) : (
              <ul className="list-group">
                {scanHistory.map((item, idx) => (
                  <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
                    <span>{item.barcode}</span>
                    <span className="text-muted" style={{ fontSize: 12 }}>{new Date(item.date).toLocaleString()}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanHistoryModal;
